/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_business_api_keys_protected_access_description = /** @type {(inputs: {}) => string} */ () => {
	return `Solicita acceso a las API empresariales para comenzar a construir tu propio ecosistema financiero con todas nuestras herramientas fintech integradas.`
};

const en_developer_business_api_keys_protected_access_description = /** @type {(inputs: {}) => string} */ () => {
	return `Request access to enterprise APIs to start building your own financial ecosystem with all our fintech tools integrated.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_business_api_keys_protected_access_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_business_api_keys_protected_access_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_business_api_keys_protected_access_description", locale)
	if (locale === "es") return es_developer_business_api_keys_protected_access_description(inputs)
	return en_developer_business_api_keys_protected_access_description(inputs)
};
export { developer_business_api_keys_protected_access_description as "developer.business_api_keys.protected.access.description" }